/**
 * Copyright (c) 2015-present, Aviabird
 *
 * @emails avia-core
 */

import CodeEditor from './CodeEditor';

export default CodeEditor;



// WEBPACK FOOTER //
// ./src/components/CodeEditor/index.js